export enum ElemAttributesTypes {
  GetElemAttributesRequest = 'SearchSettings.GetElemAttributes.Request',
  GetElemAttributesSuccess = 'SearchSettings.GetElemAttributes.Success',
  GetElemAttributesFailure = 'SearchSettings.GetElemAttributes.Failure',
  SetElemAttributeRequest = 'SearchSettings.SetElemAttribute.Request',
  SetElemAttributeSuccess = 'SearchSettings.SetElemAttribute.Success',
  SetElemAttributeFailure = 'SearchSettings.SetElemAttribute.Failure',
  ArchiveElemAttributeRequest = 'SearchSettings.ArchiveElemAttribute.Request',
  ArchiveElemAttributeSuccess = 'SearchSettings.ArchiveElemAttribute.Success',
  ArchiveElemAttributeFailure = 'SearchSettings.ArchiveElemAttribute.Failure',
  UnarchiveElemAttributeRequest = 'SearchSettings.UnarchiveElemAttribute.Request',
  UnarchiveElemAttributeSuccess = 'SearchSettings.UnarchiveElemAttribute.Success',
  UnarchiveElemAttributeFailure = 'SearchSettings.UnarchiveElemAttribute.Failure',
}
